import type { RootState } from 'models';

export const selectAppointmentDetails = ({ appointmentDetails }: RootState) => appointmentDetails;
